import { createSlice } from "@reduxjs/toolkit";

import { UserData } from "../../../constants/types";

export interface UserState {
  authToken: string | null;
  userData: UserData | null;
}

const initialState: UserState = {
  authToken: null,
  userData: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAuthToken: (
      state,
      { payload }: { payload: { authToken: string; userData: UserData } },
    ) => {
      state.authToken = payload.authToken;
      state.userData = payload.userData;
    },
    clearAuthToken: (state) => {
      state.authToken = null;
      state.userData = null;
    },
  },
});

export const actions = userSlice.actions;
export const selectors = userSlice.selectors;

export default userSlice;
